import { bostaHttp, sllrHttp } from 'http.js';

export const register = (regSrc, data) => {
  return bostaHttp.post(`/users/business/admin?regSrc=${regSrc}`, data);
};

export const sllrRegister = (regSrc, data) => {
  return bostaHttp.post(`/users/business/sllr-sign-up?regSrc=${regSrc}`, data);
};

export const sendCode = (data) => {
  return bostaHttp.post(`/users/business-admin/phone/confirm`, data);
};

export const sendCodePhone = (data) => {
  return bostaHttp.post(`/users/business-admin/phone/verify`, data);
};

export const updateVerifyPhone = (id, data) => {
  return bostaHttp.put(`/sllr/users/${id}/business`, data);
};

export const confirmVerifyEmail = (data) => {
  return bostaHttp.post(`/users/mail/confirm`, data);
};

export const sendVerificationCode = (data) => {
  return bostaHttp.post(`/users/mail/verify`, data);
};

export const getBusiness = (id) => {
  return bostaHttp.get(`/businesses/${id}/profile`);
};

export const postGetStartBusiness = (data) => {
  return bostaHttp.post(`/businesses`, data);
};

export const updateGetStartBusiness = (data, id) => {
  return bostaHttp.put(`/sllr/businesses/${id}`, data);
};

export const refreshFirebaseToken = (payload) => {
  return bostaHttp.put(`/sllr/users/refresh-firebase-token`, payload);
};

export const sendEmailForgetPassword = (email) => {
  return bostaHttp.post('/users/forget-password', { email });
};

export const login = (data) => {
  return bostaHttp.post('/users/login', data);
};

export const setNewPassword = (token, password) => {
  return bostaHttp.put(`/users/${token}/reset`, { password });
};

export const confirmChangeEmail = (data) => {
  return bostaHttp.post(`/businesses/verify-change-email`, data);
};

export const generateOTP = (id) => {
  return bostaHttp.post(`/businesses/${id}/generate-payment-otp`);
};

export const confirmOTP = (id, data) => {
  return bostaHttp.post(`/businesses/${id}/confirm-payment-otp`, data);
};

export const setShowBanner = (businessId, bannerName) => {
  const date = new Date();
  const value = JSON.parse(localStorage.getItem(bannerName));
  localStorage.setItem(
    bannerName,
    JSON.stringify({
      ...(value ? value : null),
      [businessId]: date.setDate(date.getDate() + 1)
    })
  );
};

export const getShowBanner = (businessId, bannerName) => {
  const value = JSON.parse(localStorage.getItem(bannerName));

  if (value && value[businessId]) {
    const date = Date.now();
    if (date > value[businessId]) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const getUserInfoToken = (data) => {
  return bostaHttp.get('/users/login-details', { token: data });
};

export const submitFeedbackAboutBeta = (payload) => {
  return bostaHttp.put('/businesses/sendFeedback', payload);
};

export const updateFeatureConfiguration = (payload) => {
  return bostaHttp.put('/businesses/feature-configurations', payload);
};

export const updateSllrAnnounceFlag = (payload) => {
  return sllrHttp.put('/business/announcement-flags', payload);
};

export const getUserFullData = () => {
  return bostaHttp.get('/users/fullData');
};

export const approveImpersonation = (payload) => {
  return bostaHttp.post('/users/approve-impersonation', payload);
};

export const getImpersonationPendingRequest = (adminEmail) => {
  return bostaHttp.get(`/users/pending-impersonation/${adminEmail}`);
};

export const getBusinessMembers = (id) => {
  return bostaHttp.get(`/businesses/${id}/users`);
};

export const deleteAccount = (reason, payload) => {
  return bostaHttp.delete(`/sllr/businesses?reason=${reason}`, payload);
};

export const getDeleteConditions = () => {
  return bostaHttp.get('/sllr/businesses/can-delete');
};

export const recoverAccount = (payload) => {
  return bostaHttp.post(`/businesses/recover-account`, payload);
};

export const oneTimeLogin = (data) => {
  return bostaHttp.post(`/users/one-time-login`, data);
};

export const updateBankDetailsInfo = (data) => {
  return bostaHttp.post('/businesses/add-bank-info', data);
};

export const changePassword = (payload) => {
  return bostaHttp.put('/users/change-password', payload);
};
